import { QueryClient } from '@tanstack/react-query'

export const invalidateItems = async (queryClient: QueryClient, gameId: string) => {
  queryClient.removeQueries({ queryKey: ['items', gameId], exact: false, stale: false })
  queryClient.removeQueries({ queryKey: [gameId, 'sku', 'items'], exact: false, stale: false })

  await queryClient.refetchQueries({ queryKey: ['items', gameId], exact: false })
  await queryClient.refetchQueries({ queryKey: [gameId, 'infinity-items'], exact: false })
}
